import { Box } from "@mui/material";
import React from "react";
export const MenuOffset = () => React.createElement(Box, { sx: { pt: { xs: 15, sm: 16.5, md: 12.5, xl: 18 } } });
//# sourceMappingURL=menu-offset.js.map